<template>
  <form @submit.prevent="login">
    <q-card-section>
      <p class="text-subtitle1">
        Please input the login code we emailed to you:
      </p>
      <q-input
        label="Code"
        input-mode="numeric"
        v-model="pin"
        outlined
      />
      <async-btn
        type="submit"
        :task="task"
        label="Login"
        color="primary"
        class="full-width q-mt-lg"
      />
      <q-separator class="q-my-md" />
      <resend-code-btn
        :email="command.email"
        :password="command.password"
      />
    </q-card-section>
  </form>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { mfaLogin, LoginResponse, LoginCommand } from './auth';
import ResendCodeBtn from './ResendCodeBtn.vue';

interface Data {
  pin: string,
  task: Promise<LoginResponse>|null,
}

export default defineComponent({
  emits: ['success'],
  components: { AsyncBtn, ResendCodeBtn },
  props: {
    command: {
      type: Object as () => LoginCommand,
      required: true,
    },
  },
  data(): Data {
    return {
      pin: '',
      task: null,
    };
  },
  methods: {
    login() {
      this.task = mfaLogin({ ...this.command, pin: this.pin });
      this.task.then((response) => {
        if (!response.nextAction) {
          this.$emit('success');
        }
      });
    },
  },
});
</script>
